import path from 'node:path'
import type { GeneratedFile } from '@core-engine/schema/types.js'

export function normalizeGeneratedPath(filePath: string): string {
  return filePath.split(path.sep).join('/')
}

export function createGeneratedFile(filePath: string, content: string): GeneratedFile {
  return {
    path: normalizeGeneratedPath(filePath),
    content
  }
}

export function getGeneratedFilePaths(files: GeneratedFile[]): string[] {
  return files.map((file) => file.path)
}

export function sortGeneratedFiles(files: GeneratedFile[]): GeneratedFile[] {
  return [...files].sort((a, b) => a.path.localeCompare(b.path))
}
